module.exports = __webpack_public_path__ + "static/Eat Bitter-6-cc0a3b250736cb0ce4c8820cc4e0779a.jpg";